import baseApi from '@store/api/baseApi';
import {
	setBrandInsightSummary,
	setIsPersonalSettingFetched,
	setTrendResearchProductCounts
} from '@store/actions/trend-research/TrendResearchAction';

export const onboardingApi = baseApi.injectEndpoints({
	endpoints: (builder) => ({
		fetchTrendInsightCount: builder.mutation({
			query: ({ apiSegment, requestBody = {} }) => ({
				url: `/trend-research/${apiSegment}`,
				method: 'POST',
				body: requestBody
			}),
			onQueryStarted: async (id, { dispatch, queryFulfilled }) => {
				try {
					const { data } = await queryFulfilled;
					await dispatch(setBrandInsightSummary(data));
				} catch {}
			}
		}),
		fetchOnboardingFilterOptions: builder.mutation({
			query: ({ source, requestBody = {} }) => ({
				url: `/trend-research/${source}/filter-options`,
				method: 'POST',
				body: requestBody
			})
		}),
		fetchOnboardingFilterOptionSearch: builder.mutation({
			query: ({ source, requestBody = {}, filterType, filterSearch = '' }) => ({
				url: `/trend-research/${source}/${filterType}/filter-options/search?filterSearch=${filterSearch}`,
				method: 'POST',
				body: requestBody
			})
		}),
		fetchTrendInsights: builder.mutation({
			query: ({ apiSegment, queryParams = '', requestBody = {} }) => ({
				url: `/trend-research/${apiSegment + queryParams}`,
				method: 'POST',
				body: requestBody
			}),
			onQueryStarted: async (id, { dispatch, queryFulfilled }) => {
				try {
					const { data } = await queryFulfilled;
					await dispatch(setTrendResearchProductCounts(data?.totalElements || 0));
				} catch {}
			}
		}),
		fetchTrendExploreProducts: builder.mutation({
			query: ({ source, queryParams = '', requestBody = {} }) => ({
				url: `/trend-research/${source}/products${queryParams}`,
				method: 'POST',
				body: requestBody
			}),
			onQueryStarted: async (id, { dispatch, queryFulfilled }) => {
				try {
					const { data } = await queryFulfilled;
					await dispatch(setTrendResearchProductCounts(data?.totalElements || 0));
				} catch {}
			}
		}),
		addTrendResearchPersonalSettings: builder.mutation({
			query: ({ requestBody = {} }) => ({
				url: `/personal-setting/set`,
				method: 'POST',
				body: requestBody
			})
		}),
		fetchTrendResearchPersonalSettings: builder.query({
			query: ({ key }) => ({
				url: `/personal-setting/get/${key}`,
				method: 'GET'
			}),
			onQueryStarted: async (id, { dispatch, queryFulfilled }) => {
				try {
					await queryFulfilled;
					await dispatch(setIsPersonalSettingFetched(true));
				} catch {}
			}
		})
	})
});

export const {
	useFetchOnboardingFilterOptionsMutation,
	useFetchTrendInsightCountMutation,
	useFetchTrendInsightsMutation,
	useFetchTrendExploreProductsMutation,
	useAddTrendResearchPersonalSettingsMutation,
	useFetchOnboardingFilterOptionSearchMutation,
	useLazyFetchTrendResearchPersonalSettingsQuery
} = onboardingApi;
